// Export shared types
export * from "./types";

// Export shared utilities
export * from "./utils";

// Export resolved event utilities
export * from "./utils/resolvedEvents";

// Export shared constants
export * from "./constants";

// Export auth components
export { default as SuperuserGuard } from "./components/auth/SuperuserGuard";
export { default as LoginForm } from "./components/auth/LoginForm";
export type { LoginFormConfig } from "./components/auth/LoginForm";
export { AuthProvider } from "./components/auth/AuthProvider";
export type { AuthProviderProps } from "./components/auth/AuthProvider";

// Export auth utilities
export {
  signInWithGoogle,
  signInWithEmail,
  signOut,
} from "./lib/firebase/auth";

// Export auth context and hooks
export {
  AuthContext,
  useAuth,
  type User,
  type AuthContextValue,
} from "./lib/auth/context";

// Export server-side auth utilities
export { getServerSideAuth } from "./lib/auth/server";
export type { ServerAuthConfig } from "./lib/auth/server";

// Export email queue types and constants
export * from "./types/email-queue";
export * from "./constants/email-queue";

// Export SMS queue types and constants
export * from "./types/sms-queue";
export * from "./constants/sms-queue";

// Export hooks
export { useFetchCollection } from "./lib/hooks/useFetchCollection";
export { useFetchDoc } from "./lib/hooks/useFetchDoc";
export { useIsMobile } from "./hooks/use-mobile";

// Export user utilities
export { findUserByEmailOrPhone } from "./lib/utils/user-utils";
